import _ from 'lodash';
import {RouteComponentProps} from 'react-router-dom';
import Box from '@amzn/awsui-components-react/polaris/box';
import React, {useEffect, useState} from 'react';
import AjaxStatusIndicator from '../../basic/AjaxStatusIndicator';
import { parseErrorMessage } from '../../../utils/errors';
import { Breadcrumbs } from '../../navigation/breadcrumb';
import {getExclusionGroupPageUrl} from '../../../backend/internalUrls';
import {fetchExclusionGroupDetails, fetchExclusionGroups} from '../../../backend/backend';
import ExclusionGroupsTable from './ExclusionGroupsTable';
import { ExclusionGroupDefinition, ExclusionGroupName } from '../../../backend/model';
import ExclusionGroupDetailsPanel from './ExclusionGroupDetailsPanel';
import { BreadcrumbGroupProps } from '@amzn/awsui-components-react';

type ExclusionGroupsPageProps = RouteComponentProps<{
    exclusionGroupName?: string,
}>

const ExclusionGroupsPage: React.FC<ExclusionGroupsPageProps> = (props) => {
    const [exclusionGroups, setExclusionGroups] = useState<ExclusionGroupName[]>()
    const [exclusionGroup, setExclusionGroup] = useState<ExclusionGroupDefinition>()
    const [isLoading, setIsLoading] = useState(false)
    const [errorMessages, setErrorMessages] = useState<string[]>([])

    const exclusionGroupNameFromUrl = (props.match.params.exclusionGroupName as string)?.trim() || ''

    let breadcrumbItems: BreadcrumbGroupProps.Item[] = [{text: 'Exclusion Groups', href: getExclusionGroupPageUrl()}]
    if (exclusionGroupNameFromUrl != '') {
        breadcrumbItems.push({text: exclusionGroupNameFromUrl, href: getExclusionGroupPageUrl(exclusionGroupNameFromUrl)})
    }

    const resetState = (): void => {
        setExclusionGroups(undefined)
        setExclusionGroup(undefined)
        setErrorMessages([])
    }

    useEffect(() => {
        getExclusionGroups(exclusionGroupNameFromUrl)
    }, [exclusionGroupNameFromUrl])

    const getExclusionGroups = async (exclusionGroupName: string) => {
        resetState()

        setIsLoading(true)
        if (exclusionGroupName) {
            await fetchExclusionGroupByName(exclusionGroupName)
        } else {
            setExclusionGroups((await fetchExclusionGroups()).data.exclusionGroups.map((item: string): ExclusionGroupName => ({
                name: item
            })))
        }
        setIsLoading(false)
    }

    async function fetchExclusionGroupByName(exclusionGroupName: string) {
        try {
            const rawExclusionGroupDefinition: string = (await fetchExclusionGroupDetails(exclusionGroupName)).data.exclusionGroup
            const parsedExclusionGroupDefinition: ExclusionGroupDefinition = _.pickBy(JSON.parse(rawExclusionGroupDefinition), (value) => !_.isEmpty(value))
            setExclusionGroup(parsedExclusionGroupDefinition)
        } catch (error: any) {
            console.error(error)
            setErrorMessages([parseErrorMessage(error)])
            setExclusionGroup(undefined)
        }
    }

    return <div id='exclusion-groups'>
        <Box variant="h1">Exclusion Groups</Box>
        <br/>
        <Breadcrumbs items={breadcrumbItems}/>
        <AjaxStatusIndicator errorMessage={errorMessages.join(' ')} loading={isLoading}/>
        <br/>
        {exclusionGroup && <ExclusionGroupDetailsPanel {...props} exclusionGroupName={exclusionGroupNameFromUrl} exclusionGroup={exclusionGroup}/>}
        {exclusionGroups && <ExclusionGroupsTable tableItems={exclusionGroups ?? []} fileName='DNC Exclusion Groups'/>}
        
    </div>
}

export default ExclusionGroupsPage